/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-argument */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { Component, OnChanges, Input, Output, ViewChild, EventEmitter, ChangeDetectionStrategy } from '@angular/core';
import 'devextreme/integration/jquery';
import { BizDataGridDirective } from '../shared/grid/biz-grid.directive';
import { LoadingPanelService } from '../shared/loading-panel/loading-panel.service';
import { GenericModalService, ModalSelectElement, SelectMultiChoiceTypes } from '../shared/generic-modal/generic-modal.service';
import { CurrentUserService } from '../user/services/current-user.service';
import { ConversionTable } from './models/conversion-table';
import { ConversionTableRow } from './models/conversion-table-row';
import { ConversionTableValue } from './models/conversion-table-value';
import { ConversionTableImportData } from './models/conversion-table-import-data';
import { ConversionTableService } from './services/conversion-table.service';
import { PartnerService } from './services/partner.service';
import { Partner } from './models/partner';
import { DxDataGridModule } from 'devextreme-angular';
import { DxoSelectionModule, DxoEditingModule, DxoColumnFixingModule, DxiColumnModule } from 'devextreme-angular/ui/nested';

import { PermissionRequiredDirective } from '../shared/authentication/permission-required.directive';
import { FormsModule } from '@angular/forms';

@Component({
  templateUrl: './partner-conversion-table.component.html',
  selector: 'ep-partner-conversion-table',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [DxDataGridModule, BizDataGridDirective, DxoSelectionModule, DxoEditingModule, DxoColumnFixingModule, DxiColumnModule, PermissionRequiredDirective, FormsModule]
})
export class PartnerConversionTableComponent implements OnChanges {

  constructor(
    private conversionTableService: ConversionTableService,
    private partnerService: PartnerService,
    private modalService: GenericModalService,
    private loadingPanelService: LoadingPanelService,
    private currentUserService: CurrentUserService) {
  }

  @Output() editModeChange: EventEmitter<boolean> = new EventEmitter<boolean>();

  /**
  * By settings this value only partner-specific rows are shown.
  */
  @Input() partnerId: number;
  @Input() currentConversionTable: ConversionTable;
  @Input() selectedPartner: Partner;

  @ViewChild(BizDataGridDirective, { static: true }) grid: BizDataGridDirective;
  public currentColumns: any[] = [];
  public conversionRows: any[] = [];
  public showAllPartners = false;
  public isEditable: boolean = false;
  public isDeletable: boolean = false;
  public editAllowed = false;
  public datafieldPrefix = 'conversion_column_id_';
  public foundPartners: Partner[] = [];
  public selectedRows: any[] = [];

  ngOnChanges(changes: any) {
    if (changes.currentConversionTable || changes.partnerId) {
      this.showAllPartners = false;
      this.parseConversionTable();
    }
  }

  public evaluatePermissions(permission: string, _user: any, hasPermission: boolean, partner: Partner) {
    if (permission === 'Partner_Action_InternalPartner') {
      if (partner && partner.PartnerType && partner.PartnerType.Name !== 'Internal') {
        // For non-internal partners, ignore the 'internal' permission by always granting it.
        hasPermission = true;
      }
    }
    return hasPermission;
  }

  public parseConversionTable() {
    this.currentColumns = [];
    this.conversionRows = [];

    if (this.grid.instance) {
      this.grid.instance.cancelEditData(); // Make sure previous state is cancelled...
    }

    if (this.currentConversionTable) {

      if (this.currentConversionTable.IsUniversal) {
        this.editAllowed = this.currentUserService.hasPermission('Partner_Action_ConversionTableDataEditUniversal');
      }
      else {
        this.editAllowed = this.currentUserService.hasPermission('Partner_Action_ConversionTableDataEdit');
      }

      if (this.partnerId) {
        this.currentColumns.push({
          dataField: 'partner.PartnerName',
          caption: 'Partner',
          dataType: 'string',
          allowEditing: false,
          width: this.currentConversionTable.Columns.length > 0 ? 150 : undefined
        });
      }
      else {
        this.currentColumns.push({
          dataField: 'row.IsDefault',
          caption: 'Default',
          dataType: 'boolean',
          width: this.currentConversionTable.Columns.length > 0 ? 120 : undefined
        });
      }

      this.currentColumns.push({
        dataField: 'row.RowNumber',
        caption: 'Row Id',
        dataType: 'number',
        visible: false,
        width: 100,
        sortOrder: 'asc'
      });

      this.currentConversionTable.Columns.sort((c1, c2) => c1.SortOrder - c2.SortOrder).forEach(column => {
        this.currentColumns.push({
          dataField: this.datafieldPrefix + column.ColumnId,
          caption: column.ColumnName,
          dataType: 'string'
        });
      });
      const partnerIds: number[] = [];

      this.currentConversionTable.Rows.forEach(row => {
        let addRow = true;

        if (this.partnerId) { // Show partner specific rows
          addRow = row.PartnersId && (this.showAllPartners || this.partnerId === row.PartnersId);

          // Collect partner-ids
          if (row.PartnersId && partnerIds.indexOf(row.PartnersId) < 0) {
            partnerIds.push(row.PartnersId);
          }
        }
        else if (row.PartnersId) { // Only show non-partner specific rows
          addRow = false;
        }

        if (addRow) {
          const gridRow: any = {};
          gridRow.IsDefault = row.IsDefault;
          row.Values.forEach(value => {
            gridRow[this.datafieldPrefix + value.ColumnId] = value.Value;
          });
          gridRow.row = row;
          this.conversionRows.push(gridRow);
        }
      });

      // Make sure we load 'current partner' so we can show the partner-name when creating new rows...
      if (this.partnerId && partnerIds.indexOf(this.partnerId) < 0) {
        partnerIds.push(this.partnerId);
      }

      if (partnerIds.length > 0) {
        this.grid.showLoadingPanel('Loading Partner Data...');
        // Load light-partners because we only need the name of the partner
        void this.partnerService.getLightPartners(partnerIds).then(partners => {
          this.foundPartners = partners;

          this.conversionRows.forEach(row => {
            const partner = partners.find(p => p.PartnersId === row.row.PartnersId);
            row.partner = partner;
          });
          this.grid.hideLoadingPanel();
          this.grid.instance.refresh();
          this.grid.instance.repaint();
        });
      }
      else {
        this.grid.instance.refresh();
        this.grid.instance.repaint();
      }
    }
  }

  showPartners(showAll: boolean) {
    this.showAllPartners = showAll;

    if (this.currentConversionTable !== null) {
      this.loadingPanelService.showLoadingPanelDirect('Loading Conversion Table data');
      void this.conversionTableService.getFullConversionTable(this.currentConversionTable.Id, this.partnerId, this.showAllPartners).then(ct => {
        this.currentConversionTable = ct;
        this.loadingPanelService.hideLoadingPanel();
        this.parseConversionTable();
      });
    }
    else {
      this.currentConversionTable = null;
      this.parseConversionTable();
    }
  }

  onCellPrepared(e: any) {

    if (e.rowType === 'header') {
      if (this.currentConversionTable) {
        const column = this.currentConversionTable.Columns.find(c => this.datafieldPrefix + c.ColumnId === e.column.dataField);
        if (column) {
          e.cellElement.attr('title', column.Description);
        }
      }
    }
    else if (e.rowType === 'data') {
      if (this.partnerId && this.partnerId !== e.data.row.PartnersId) {
        e.cellElement.css('color', '#4c90ca');
      }
    }
  }

  onEditingStart(e: any) {
    if (this.partnerId) {
      e.cancel = e.data.row.PartnersId !== this.partnerId; // Make rows for other partners readonly
    }
  }

  editGrid() {
    this.setEditMode(true);
  }

  saveGrid() {
    this.setEditMode(false);
    this.grid.showLoadingPanel('Saving...');
    this.grid.instance.saveEditData().then(() => {
      this.grid.hideLoadingPanel();
    });
  }

  cancelGrid() {
    this.setEditMode(false);
    this.grid.instance.cancelEditData();
  }

  setEditMode(isEditable: boolean) {
    this.isEditable = isEditable;
    this.editModeChange.emit(isEditable);
  }

  initNewRow(e: any) {
    e.data = {};
    const conversionTableRow = new ConversionTableRow();
    conversionTableRow.ConversionTableId = this.currentConversionTable.Id;
    conversionTableRow.PartnersId = this.partnerId;
    conversionTableRow.RowNumber = this.findNextRowNumber();
    e.data.IsDefault = false;

    if (this.partnerId) {
      // If this is a partner-specific table - set partner on new rows...
      e.data.partner = this.foundPartners.find(p => p.PartnersId === this.partnerId);
    }

    e.data.row = conversionTableRow;
  }

  private nextRowNumber = 0;
  private findNextRowNumber(): number {
    if (this.conversionRows) {
      let temp = Math.max(...this.conversionRows.map(r => r.row.RowNumber)) + 1;
      if (temp > this.nextRowNumber) {
        this.nextRowNumber = temp++;
      }
      else {
        this.nextRowNumber++;
      }

      return this.nextRowNumber;
    }
    else {
      return 1;
    }
  }

  insertRow(e: any) {
    this.setEditMode(false);
    const deferred = $.Deferred(); // REVIEW: Fix this when Promise/Observable is fully supported by DevExpress

    const conversionTableRow = e.data.row as ConversionTableRow;
    conversionTableRow.IsDefault = e.data.IsDefault;

    this.mergeRowValues(e.data, conversionTableRow);
    this.conversionTableService.saveRow(conversionTableRow).then(savedRow => {
      this.currentConversionTable.Rows.push(savedRow); // Add the row to the conversion-table so the row won't get lost when calling the 'parseConversionTable' method
      e.data.row = savedRow;
      deferred.resolve();
    }).catch(() => {
      this.grid.hideLoadingPanel();
      this.grid.instance.refresh();
      this.grid.instance.repaint();
    });
    e.cancel = deferred.promise();
  }

  updateRow(e: any) {
    this.setEditMode(false);
    const deferred = $.Deferred(); // REVIEW: Fix this when Promise/Observable is fully supported by DevExpress

    const clonedRow = Object.assign({}, e.key.row); // Clone the conversion-table-row so we don't modify it before it's successfully saved

    if (e.newData.IsDefault !== undefined && e.newData.IsDefault !== null) {
      clonedRow.IsDefault = e.newData.IsDefault;
    }

    if (e.newData.row) { // If row-specific properties like 'IsDefault' is set - merge the updated values with the row object
      Object.assign(clonedRow, e.newData.row);
    }

    this.mergeRowValues(e.newData, clonedRow); // Merge grid-data into the conversion-table-row
    this.conversionTableService.saveRow(clonedRow).then(savedRow => {
      e.key.row = savedRow; // Set the saved row

      //If a new column has been added before updating a row then values for the new column does not show up before grid refresh/repaint
      this.grid.instance.refresh();
      this.grid.instance.repaint();

      deferred.resolve();
    }).catch(() => {
      this.grid.hideLoadingPanel();
      this.grid.instance.refresh();
      this.grid.instance.repaint();
    });

    e.cancel = deferred.promise();
  }

  removeRow(e: any) {
    this.setEditMode(false);
    const deferred = $.Deferred(); // REVIEW: Fix this when Promise/Observable is fully supported by DevExpress
    if (e.data.row && e.data.row.RowId) { // Only call backend if it's a row already stored in the database
      void this.conversionTableService.deleteRow(e.data.row.RowId).then(() => {
        // Find index of the row to delete in the current conversion-table
        const indexToRemove = this.currentConversionTable.Rows.findIndex(r => r.RowId === e.data.row.RowId);
        // Remove the row from the in-memory stored conversion-table.
        this.currentConversionTable.Rows.splice(indexToRemove, 1);
        deferred.resolve();
      });
    }
    else {
      deferred.resolve();
    }
    e.cancel = deferred.promise();
  }

  /**
   * Merge the values from the gridRow (the temp objects) into the given conversion-table-row.
   * @param gridRow
   * @param conversionTableRow
   */
  mergeRowValues(gridRow: any, conversionTableRow: ConversionTableRow) {
    for (const key in gridRow) {
      if (key.indexOf(this.datafieldPrefix) >= 0) { // Only handle values bound to a column
        const value = gridRow[key];
        const columnId = +key.replace(this.datafieldPrefix, '');

        conversionTableRow.Values = conversionTableRow.Values || [];

        let rowValue = conversionTableRow.Values.find(v => v.ColumnId === columnId);
        if (!rowValue) { // If it's a new value...
          rowValue = new ConversionTableValue();
          rowValue.ColumnId = columnId;
          rowValue.RowId = conversionTableRow.RowId;
          conversionTableRow.Values.push(rowValue);
        }

        rowValue.Value = value;
      }
    }
  }

  importData() {
    const delimiters: ModalSelectElement[] = [];
    delimiters.push(new ModalSelectElement('Comma (,)', ','));
    delimiters.push(new ModalSelectElement('Semicolon (;)', ';'));
    delimiters.push(new ModalSelectElement('Tabulator (TAB)', '\t'));

    this.modalService.selectMultiChoiceDirect('Select delimiter', 'Please choose the delimiter', delimiters, delimiters[0], SelectMultiChoiceTypes.DropDown).then((delimiter: ModalSelectElement) => {
      this.modalService.inputDirect('Import Data', 'Paste in the data to import', undefined, undefined, true, 20, 10).then(dataToImport => {
        this.parseImportedData(dataToImport, delimiter.value);
      }).catch(() => { });
    }).catch(() => { });
  }

  selectionChanged(e: any) {
    this.selectedRows = e.selectedRowsData;
    this.isDeletable = this.selectedRows.length > 0;
  }

  deleteData() {
    if (this.selectedRows.length > 0) {
      this.modalService.confirmDirect('Delete Conversion Line', 'Are you sure you want to delete the selected ' + this.selectedRows.length + ' conversion line(s)?').then(() => {
        const conversionTableRowIds = this.selectedRows.map((c) => c.row.RowId);
        conversionTableRowIds.forEach((rowId) => {
          void this.conversionTableService.deleteRow(rowId).then(() => {
            // Find index of the row to delete in the current conversion-table
            const indexToRemove = this.currentConversionTable.Rows.findIndex(r => r.RowId === rowId);
            // Remove the row from the in-memory stored conversion-table.
            this.currentConversionTable.Rows.splice(indexToRemove, 1);
            this.parseConversionTable();
          });
        });
      }).catch(() => { });
    }
  }

  parseImportedData(dataToImport: string, delimiter: string) {
    const data = new ConversionTableImportData();
    data.ConversionTableId = this.currentConversionTable.Id;
    data.DataToImport = dataToImport;
    data.Delimiter = delimiter;
    data.PartnerId = this.partnerId;

    this.loadingPanelService.showLoadingPanelDirect('Importing data...');
    void this.conversionTableService.parseDataToImport(data).then(parsedRows => {
      parsedRows.forEach(row => this.currentConversionTable.Rows.push(row));
      this.loadingPanelService.hideLoadingPanel();
      this.parseConversionTable();
    });
  }

}
